export const GENERIC_DIALOG_KEY = 'pwaDialog';
export const MODAL_DIALOG_KEY = 'pwaDialogNested';
export const MODAL_DIALOG_ID = 'modalDialog';
export const SIDE_MODAL_DIALOG_ID = 'sideModalDialog';
export const SHEET_DIALOG_INTERACTION_DELAY = 120;
export  const SIDE_MODAL_CLOSE_TIMEOUT = 300;
